import * as React from 'react'

import { CloudDownloadIcon, Link2Icon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { QRCode } from '~/client/src/shared/components/LazyQRCode'
import { ReactToPrint } from '~/client/src/shared/components/LazyReactToPrint'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import ThemeMode from '~/client/src/shared/utils/ThemeModeManager'
import { toast } from '~/client/src/shared/utils/toast'

import Colors from '~/client/src/shared/theme.module.scss'

const QR_CODE_LOGO_SRC = '/static/icons/strux-hub-dark-with-background.svg'

interface IProps {
  name: string
  openQR: () => void
  getPrintContent: () => HTMLDivElement
  url: string
  icon: JSX.Element
}

@observer
export default class QRCodeHolder extends React.Component<IProps> {
  public render(): JSX.Element {
    const { name, getPrintContent, openQR, url, icon } = this.props

    return (
      <div className="no-grow col qr-code-holder relative x-center">
        <div className="absolute qr-code-download beautiful-shadow brada4 ba-palette-brand-lighter pa5 tw:flex tw:flex-col">
          <ReactToPrint
            trigger={this.renderPrintTrigger}
            content={getPrintContent}
          />
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label={Localization.translator.copyLink}
            onClick={this.copyLinkToClipboard}
          >
            <Link2Icon className="tw:text-muted-foreground" />
          </Button>
        </div>
        <div className="col" onClick={openQR}>
          <QRCode
            value={url}
            logoImage={QR_CODE_LOGO_SRC}
            size={240}
            fgColor={ThemeMode.getHEXColor(Colors.neutral0)}
          />
          <div className="row x-center text bold large">
            {icon}
            {name}
          </div>
        </div>
      </div>
    )
  }

  private renderPrintTrigger(): JSX.Element {
    return (
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={Localization.translator.download}
      >
        <CloudDownloadIcon className="tw:text-muted-foreground" />
      </Button>
    )
  }

  private copyLinkToClipboard = (): void => {
    window.navigator.clipboard.writeText(this.props.url)

    toast.success(Localization.translator.copiedToClipboard)
  }
}
